/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: User_API.js
 *  @description: Этот файл является частью клиентской стороны проекта. src Относится к части, которая занимается формированием запросов к серверной части проекта. User_API.js
 *	@author: Белов Михаил Александрович, Горбас Александр Петрович
*/
import { $authHost } from './index';
import jwt_decode from 'jwt-decode';
import Cookies from 'js-cookie';

export const check = async () => {
    try {
        //  Если токен уже есть, но он повреждён - удалить его, прежде чем отправлять запрос на проверку данных.
        if (Cookies.get('token'))
        {
            try
            {
                const decoded = jwt_decode(Cookies.get('token'));

                if (decoded?.id === 1)
                    throw new Error('Демо-доступ не предусмотрен', { cause: { code: 403 } });

		localStorage.setItem('token', Cookies.get('token'));
            }catch (error)
            {
                console.error(error);

                Cookies.remove('token');

                throw error;
            }
        }else{
            //  Токена ещё нет, но он должен быть. Значит, это ошибка.
            throw new Error('Не авторизован (1) / Not authorized (1)', { cause: { code: 403 } });
        }

        //  Отправить запрос на проверку авторизации.
        const { data } = await $authHost.get('api/user/auth');

        if (data?.error)
            throw new Error(data.error);

        if (data?.token !== null)
        {
            return {
                user: data.user,
            };
        }
        else
        {
            throw new Error('Не авторизован (2) / Not authorized (2)', { cause: { code: 403 } });
        }
    } catch (error) {
        console.error('check Ошибка при запросе на сервер:', error.message);

        Cookies.remove('token');

        throw error;
    }
}
